module.exports = __webpack_public_path__ + "img/icon1.adcffb7.webp";